import useController from "@hooks/useController";

export default function useSettingsController(): Customer.Controllers.Settings {
    const controller = useController('/api/customer/settings')

    const details = (data: object) => controller.patch('details', data)
    const update = (data: object) => controller.patch(undefined, data)
    const password = (data: object) => controller.patch('details', data)
    const destroy = () => controller.del()

    return { details, update, password, destroy }
}